import styled, { css } from 'styled-components';
import { media, layout, remCalc } from 'src/components/base';
import { OffersGrid } from 'src/areas/product-collection/components/offers-grid';
import AdContainer from '../../../../components/ads';

const compensateForPadding = layout.gridColumnGutter.small.value / 2;

export const Empty = styled.section`
  margin-top: ${layout.margins.component.desktop.rem};
  width: 100%;
  a {
    display: block;
    margin-top: 1rem;
    text-decoration: underline;
  }

  ul {
    padding-left: 40px;
  }
`;

export const Container = styled.div`
  div:empty,
  a:empty {
    height: 0;
    padding: 0 !important;
    border-bottom: 0 !important;
  }
`;

export const ProductCount = styled.div`
  display: none;

  ${media.smallOnly`
    display: flex;
    justify-content: center;
    color: ${p => p.theme.colors.base600};
    padding: ${remCalc(5)} ${remCalc(0)} ${remCalc(10)} ${remCalc(0)};
  `}
`;

export const SearchField = styled.div<{ show: boolean }>`
  display: none;
  width: 100%;

  ${props =>
    props.show &&
    css`
      display: block;
    `}
`;

export const Panel = styled.div``;

export const Ad = styled(AdContainer)<{
  mobilePosition?: boolean;
  panoramaPosition?: boolean;
}>`
  margin-top: 5px;
  margin-bottom: 5px;

  &:empty {
    display: none;
  }

  ${props =>
    props.mobilePosition &&
    css`
      ${Panel} && {
        width: 100%;
        order: 9;

        @media screen and (max-width: 1023px) {
          order: 11;
        }
        @media screen and (max-width: 824px) {
          order: 9;
        }
        @media screen and (max-width: 340px) {
          > iframe {
            margin-left: ${compensateForPadding};
            margin-right: ${compensateForPadding};
          }
        }
      }
    `}

  ${props =>
    props.panoramaPosition &&
    css`
      ${Panel} && {
        max-width: 100%;
        order: 9;

        @media screen and (max-width: 1023px) {
          order: 11;
        }
        @media screen and (max-width: 822px) {
          order: 9;
        }
      }
    `}
`;

const ITEMS_DESKTOP = 3;
const SIZE_DESKTOP = `${100 / ITEMS_DESKTOP}%`;
const GAP_DESKTOP = 1;
const GUTTER_DESKTOP = `(${
  GAP_DESKTOP * (ITEMS_DESKTOP - 1)
}rem / ${ITEMS_DESKTOP})`;

export const DealsGrid = styled(OffersGrid)`
  ${media.largeUp`
      grid-template-columns: repeat(auto-fill, minmax(auto, calc(${SIZE_DESKTOP} - ${GUTTER_DESKTOP})))
    `}
`;
